<div class="chart">
  <div
    class="chartTitle"
    [ngClass]="[!hasEdit ? 'preview' : '']"
    *ngIf="!preview"
  >
    <div
      class="title"
      style="height: 30px; width: 85%"
      matTooltip="{{ title }}"
      matTooltipPosition="right"
    >
      {{ title }}
    </div>
    <fa-icon
      [icon]="faCircleInfo"
      class="pencil"
      *ngIf="description"
      matTooltip="Description: {{ description }}"
      matTooltipPosition="right"
      matTooltipClass="report-home-tooltip"
    ></fa-icon>
  </div>
  <div class="chartTitle" *ngIf="preview">
    <div
      class="title"
      style="height: 30px; width: 85%; margin-left: -30px"
      matTooltip="{{ title }}"
      matTooltipPosition="right"
    >
      {{ title }}
    </div>
    <fa-icon
      [icon]="faCircleInfo"
      class="pencil"
      *ngIf="description"
      matTooltip="Description: {{ description }}"
      matTooltipPosition="right"
      matTooltipClass="report-home-tooltip"
    ></fa-icon>
  </div>
  <ng-container *ngIf="!data || data.length <= 0">
    <div class="noData">
      <span class="blank_img">
        <fa-icon [icon]="faRectangleList"></fa-icon>
        <ng-container *ngIf="hasEdit">
          <div
            *ngIf="
              (!preview || hasEdit) &&
              dataPoints.data &&
              dataPoints.data.length <= 0
            "
          >
            Choose one or more fields to display in the list
          </div>
          <div
            *ngIf="dataPoints && dataPoints.data && dataPoints.data.length >= 1"
          >
            There is no data to display<br />
            Review Chart Settings or Filters if this is unexpected
          </div>
          <div
            *ngIf="preview && dataPoints.data && dataPoints.data.length <= 0"
          >
            No visible fields to display
          </div></ng-container
        ></span
      >
    </div>
  </ng-container>

  <ng-container *ngIf="referenceLink != '' && canvasMode == 'edit'">
    <a class="referenceLink" href="{{ referenceLink }}" target="_blank"
      ><fa-icon [icon]="faEdit"></fa-icon>Link to page record</a
    >
  </ng-container>

  <div
    *ngIf="data && data.length > 0"
    class="container"
    [ngClass]="[
      canvasMode != 'edit' && canvasType == 'dashboard'
        ? 'dashBoardContainer'
        : 'reportContainer'
    ]"
  >
    <ng-container *ngFor="let datarow of rowsToDisplay; let i = index">
      <ng-container *ngIf="datarow[0][1].hasOwnProperty('color')">
        <ng-container *ngIf="datarow[0][0] == 'referenceLink'">
          <ng-container
            *ngIf="datarow[0][1].value != '' && canvasMode != 'edit'"
          >
            <a
              class="referenceLink"
              href="{{ datarow[0][1].value }}"
              target="_blank"
              ><fa-icon [icon]="faEdit"></fa-icon>Link to page record</a
            >
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!datarow[0][1].hasOwnProperty('color')">
        <ng-container *ngIf="datarow[0][0][1] != '' && canvasMode != 'edit'">
          <a class="referenceLink" href="{{ datarow[0][0][1] }}" target="_blank"
            ><fa-icon [icon]="faEdit"></fa-icon>Link to page record</a
          >
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let item of datarow">
        <ng-container *ngIf="item[1].hasOwnProperty('color')">
          <div
            class="row"
            [ngClass]="{
              condensed:
                canvasMode == 'view' ||
                (canvasMode == 'edit' && datarow.length > 5)
            }"
            *ngIf="item[0] != 'referenceLink'"
          >
            <label>{{ item[0] }}</label
            ><span
              [ngStyle]="{
                color: item[1].color
              }"
              >{{ item[1].value }}</span
            >
          </div>
        </ng-container>
      </ng-container>

      <HR *ngIf="i + 1 < rowsToDisplay.length" />
    </ng-container>
  </div>

  <span
    class="disclaimer"
    *ngIf="
      dataPoints &&
      dataPoints.data &&
      dataPoints.data.length >= 1 &&
      canvasMode == 'edit'
    "
    >Showing the first line of data, and the full data listing will be included
    on export</span
  >
  <span
    class="disclaimer"
    *ngIf="
      dataPoints &&
      dataPoints.data &&
      dataPoints.data.length >= 1 &&
      canvasMode != 'edit'
    "
  ></span>
</div>
